module.exports = __webpack_public_path__ + "img/sessime.edf76f79.jpg";